import { useFormikContext } from 'formik';
import { useEffect } from 'react';

export const useTouchedValidation = () => {
  const { touched, values, validateField } = useFormikContext<any>();
  useEffect(() => {
    const validateTouchedFields = (obj: any, path: string[] = []) => {
      Object.keys(obj).forEach((key) => {
        const currentPath = [...path, key];
        const value = obj[key];

        if (value === true) {
          // console.log('start useTouchedValidation');
          // поле было тронуто → валидируем
          const fieldPath = currentPath.join('.');
          validateField(fieldPath);
        } else if (typeof value === 'object' && value !== null) {
          // вложенные объекты/массивы → рекурсивно
          validateTouchedFields(value, currentPath);
        }
      });
    };
    validateTouchedFields(touched);
  }, [touched, values, validateField]);
};
